import {Component, OnInit} from '@angular/core';
import {VacanciesCategoryService} from './vacancies-category.service';
// import { error } from 'console';

@Component({
  selector: 'app-vacancies-category',
  templateUrl: './vacancies-category.component.html',
  styleUrls: ['./vacancies-category.component.css']
})
export class VacanciesCategoryComponent implements OnInit {
  public departments: any;

  constructor(private vacanciesCategoryService: VacanciesCategoryService) {
  }

  ngOnInit(): void {
    this.getDepartmentsWithVacancyCount();
  }

  getDepartmentsWithVacancyCount() {
    this.vacanciesCategoryService.getDepartmentsWithVacancyCount()
      .subscribe(response => {
        this.departments = response;
      }, error => {
        console.error('Error fetching departments:', error)
      });
  }

}
